import { Component, Inject } from '@angular/core';
import { clearInterval, setInterval } from 'worker-timers';
import * as i0 from "@angular/core";
import * as i1 from "../services/login.service";
import * as i2 from "@angular/common";
import * as i3 from "@ngx-translate/core";
export class InactivityCountdownComponent {
  destroyed;
  loginService;
  portalLink;
  INACTIVITY_COUNTDOWN_DURATION = 5 * 60 * 1000;
  isAcceptDisabled;
  onRejectClick;
  timeRemaining;
  intervalId;
  constructor(destroyed, loginService, portalLink) {
    this.destroyed = destroyed;
    this.loginService = loginService;
    this.portalLink = portalLink;
    this.timeRemaining = this.INACTIVITY_COUNTDOWN_DURATION;
  }
  ngOnInit() {
    this.intervalId = setInterval(() => {
      this.timeRemaining -= 1000;
      if (this.timeRemaining <= 0) {
        this.onTimerComplete();
        this.stopTimer();
      }
    }, 1000);
  }
  stopTimer() {
    if (this.intervalId) {
      clearInterval(this.intervalId);
      this.intervalId = undefined;
    }
  }
  onAcceptClick() {
    this.stopTimer();
  }
  onTimerComplete() {
    const lastChar = this.portalLink.slice(-1);
    const redirectUrl = this.portalLink + (lastChar === '/' ? 'logged-out' : '/logged-out');
    this.loginService.logoutAndRedirect(redirectUrl);
  }
  static ɵfac = function InactivityCountdownComponent_Factory(t) {
    return new (t || InactivityCountdownComponent)(i0.ɵɵdirectiveInject(i0.DestroyRef), i0.ɵɵdirectiveInject(i1.LoginService), i0.ɵɵdirectiveInject('portalLink'));
  };
  static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
    type: InactivityCountdownComponent,
    selectors: [["geaui-inactivity-countdown"]],
    decls: 22,
    vars: 23,
    consts: [[1, "gea-font-heading-24", "title"], [1, "gea-font-body-16"], [1, "countdown-container", "gea-font-heading-20"], [1, "timer"]],
    template: function InactivityCountdownComponent_Template(rf, ctx) {
      if (rf & 1) {
        i0.ɵɵelementStart(0, "div", 0);
        i0.ɵɵtext(1);
        i0.ɵɵpipe(2, "translate");
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(3, "div", 1);
        i0.ɵɵtext(4);
        i0.ɵɵpipe(5, "translate");
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(6, "div", 2)(7, "div");
        i0.ɵɵtext(8);
        i0.ɵɵpipe(9, "translate");
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(10, "div", 3);
        i0.ɵɵtext(11);
        i0.ɵɵpipe(12, "date");
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(13, "div");
        i0.ɵɵtext(14);
        i0.ɵɵpipe(15, "translate");
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(16, "div", 3);
        i0.ɵɵtext(17);
        i0.ɵɵpipe(18, "date");
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(19, "div");
        i0.ɵɵtext(20);
        i0.ɵɵpipe(21, "translate");
        i0.ɵɵelementEnd()();
      }
      if (rf & 2) {
        i0.ɵɵadvance();
        i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(2, 7, "INACTIVITY.DIALOG.TITLE"));
        i0.ɵɵadvance(3);
        i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(5, 9, "INACTIVITY.DIALOG.CONTENT"));
        i0.ɵɵadvance(4);
        i0.ɵɵtextInterpolate1("", i0.ɵɵpipeBind1(9, 11, "INACTIVITY.DIALOG.TIMER.TITLE"), " :");
        i0.ɵɵadvance(3);
        i0.ɵɵtextInterpolate(i0.ɵɵpipeBind2(12, 13, ctx.timeRemaining, "mm"));
        i0.ɵɵadvance(3);
        i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(15, 16, "INACTIVITY.DIALOG.MINUTES"));
        i0.ɵɵadvance(3);
        i0.ɵɵtextInterpolate(i0.ɵɵpipeBind2(18, 18, ctx.timeRemaining, "ss"));
        i0.ɵɵadvance(3);
        i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(21, 21, "INACTIVITY.DIALOG.SECONDS"));
      }
    },
    dependencies: [i2.DatePipe, i3.TranslatePipe],
    styles: [".title[_ngcontent-%COMP%]{padding:48px 0 24px}.countdown-container[_ngcontent-%COMP%]{display:flex;flex-direction:row;padding:24px 0 48px;gap:4px}.countdown-container[_ngcontent-%COMP%]   .timer[_ngcontent-%COMP%]{min-width:27px}"]
  });
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(InactivityCountdownComponent, [{
    type: Component,
    args: [{
      selector: 'geaui-inactivity-countdown',
      template: "<div class=\"gea-font-heading-24 title\">{{ 'INACTIVITY.DIALOG.TITLE' | translate }}</div>\n<div class=\"gea-font-body-16\">{{ 'INACTIVITY.DIALOG.CONTENT' | translate }}</div>\n<div class=\"countdown-container gea-font-heading-20\">\n  <div>{{ 'INACTIVITY.DIALOG.TIMER.TITLE' | translate }} :</div>\n  <div class=\"timer\">{{ timeRemaining | date: 'mm' }}</div>\n  <div>{{ 'INACTIVITY.DIALOG.MINUTES' | translate }}</div>\n  <div class=\"timer\">{{ timeRemaining | date: 'ss' }}</div>\n  <div>{{ 'INACTIVITY.DIALOG.SECONDS' | translate }}</div>\n</div>\n",
      styles: [".title{padding:48px 0 24px}.countdown-container{display:flex;flex-direction:row;padding:24px 0 48px;gap:4px}.countdown-container .timer{min-width:27px}\n"]
    }]
  }], () => [{
    type: i0.DestroyRef
  }, {
    type: i1.LoginService
  }, {
    type: undefined,
    decorators: [{
      type: Inject,
      args: ['portalLink']
    }]
  }], null);
})();
